import request from '@/utils/request'

// 查询老师列列表
export function listTeacher (query) {
  return request({
    url: '/system/teacher/list',
    method: 'get',
    params: query
  })
}

// 查询大区/区域/校区
export function listRegion () {
  return request({
    url: '/system/region/tree',
    method: 'get'
  })
}

// 查询bmxx
export function listBmxx () {
  return request({
    url: '/system/teacher/bmxxTree',
    method: 'get'
  })
}

// 查询老师列详细
export function getTeacher (id) {
  return request({
    url: '/system/teacher/' + id,
    method: 'get'
  })
}

// 新增老师列
export function addTeacher (data) {
  return request({
    url: '/system/teacher',
    method: 'post',
    data: data
  })
}

// 修改老师列
export function updateTeacher (data) {
  return request({
    url: '/system/teacher',
    method: 'put',
    data: data
  })
}

// 删除老师列
export function delTeacher (id) {
  return request({
    url: `/system/teacher/${id}`,
    method: 'delete'
  })
}

//根据课程id查询教师
export function getTeacherBySubjectId (id) {
  return request({
    url: `/system/teacher/available/${id}`,
    method: 'get'
  })
}

//查询教师列列表(全部)
export function getAllTeacher (id) {
  return request({
    url: `/system/teacher/list/param?enable=1`,
    method: 'get'
  })
}
